export default {
  data() {
    return {
      RZSSForm: {
        sfyrzxq: "",
        rzls: "",
        rzfs: "",
        zqrzxqje: "",
        gqrzxqje: "",
        sfss: "",
        sfyssjh: "",
        jhssmk: "",
        ssmk: ""
      },
      RZSSRules: {
        rzls: [
          {
            required: true,
            message: "请选择融资轮数",
            trigger: ["change"]
          }
        ],
        rzfs: [
          {
            required: true,
            message: "请选择融资方式",
            trigger: ["change"]
          }
        ],
        zqrzxqje: [
          {
            required: true,
            message: "请选择债权融资需求金额",
            trigger: ["change"]
          }
        ],
        gqrzxqje: [
          {
            required: true,
            message: "请选择股权融资需求金额",
            trigger: ["change"]
          }
        ],
        sfyssjh: [
          {
            required: true,
            message: "请选择是否有上市计划",
            trigger: ["change"]
          }
        ],
        jhssmk: [
          {
            required: true,
            message: "请选择计划上市模块",
            trigger: ["change"]
          }
        ],
        ssmk: [
          {
            required: true,
            message: "请选择请选择上市模块",
            trigger: ["change"]
          }
        ]
      },
      selectList: [
        { name: "10人以下（含10人）", code: "1" },
        { name: "10-50人（含50人）", code: "2" },
        { name: "50-200人（含200人）", code: "3" },
        { name: "200-500人（含500人）", code: "4" },
        { name: "500-1000人（含1000人）", code: "5" },
        { name: "1000人以上", code: "6" }
      ],
      rzlsList: [
        { name: "天使/种子轮", code: "1" },
        { name: "Pre-A至A+轮", code: "2" },
        { name: "Pre-B至B+轮", code: "3" },
        { name: "Pre-C至C+轮", code: "4" },
        { name: "D轮及以上", code: "5" }
      ],
      zqrzxqjeList: [
        { name: "100万以下（含100万）", code: "1" },
        { name: "100-500万（含500万）", code: "2" },
        { name: "500-1000万（含1000万）", code: "3" },
        { name: "500-1000万（含1000万）", code: "4" },
        { name: "5000万-1亿（含1亿）", code: "5" },
        { name: "1亿以上", code: "6" }
      ],
      sfyssjhList: [
        { name: "是", code: "1" },
        { name: "否", code: "2" }
      ],
      jhssmkList: [
        { name: "上证-主板", code: "1" },
        { name: "上证-科创板", code: "2" },
        { name: "深证-主板", code: "3" },
        { name: "深圳-中小板", code: "4" },
        { name: "深证-创业板", code: "5" },
        { name: "香港-主板", code: "6" },
        { name: "新三板-精选层", code: "7" },
        { name: "新三板-其他", code: "8" }
      ]
    };
  },
  methods: {
    sfssChange() {
      this.RZSSForm.sfyssjh = "";
      this.RZSSForm.jhssmk = "";
      this.RZSSForm.ssmk = "";
      this.$refs["RZSSForm"].clearValidate();
    },
    sfyrzxqChange() {
      this.RZSSForm.rzfs = "";
      this.$refs["RZSSForm"].clearValidate();
    },
    rzfsChange() {
      this.RZSSForm.zqrzxqje = "";
      this.RZSSForm.gqrzxqje = "";
      this.$refs["RZSSForm"].clearValidate();
    }
  }
};
